import { Component, OnInit } from '@angular/core';
import { ToolsService } from '../../core/services/tools.service';
import { IntlService } from '../../core/services/intl.service';
import { Subscription } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-language-picker',
  templateUrl: './language-picker.component.html',
  styleUrls: ['./language-picker.component.scss']
})
export class LanguagePickerComponent implements OnInit {

  public selectedLanguage: string;
  public languages = [];

  public languageSubscription: Subscription;

  constructor(public toolsService: ToolsService, private intlService: IntlService) { }

  ngOnInit() {
    this.selectedLanguage = this.intlService.getCurrentLanguage();
    this.languages = this.intlService.getAvailableLanguages();

    this.languageSubscription = this.intlService.languageChanged().subscribe((lang) => {
      this.selectedLanguage = lang;
    });
  }

  setLanguage(lang: string) {
    this.intlService.setCurrentLanguage(lang);
  }

}
